module.exports = __webpack_public_path__ + "static/media/googlePin6.242657a8.svg";